import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "810",
  height: "621",
  viewBox: "0 0 810 621",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#CEC8C4",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M405.983 282.611V3.0493C405.983 0.317489 402.642 -1.03368 400.735 0.932119L281.999 123.562C257.717 113.294 231.021 107.61 202.988 107.61C90.879 107.61 0 198.449 0 310.498C0 422.543 90.879 513.381 202.988 513.381C305.628 513.381 390.416 437.234 404.024 338.382V617.941C404.024 620.689 407.357 622.031 409.265 620.068L527.999 497.439C552.281 507.704 578.987 513.381 607.012 513.381C719.119 513.381 810 422.543 810 310.498C810 198.449 719.119 107.61 607.012 107.61C504.371 107.61 419.584 183.765 405.983 282.611Z"
    }, null, -1)
  ]))]))
}
export default { render: render }